module.exports = __webpack_public_path__ + "img/EWY_Logo_Claim_Salvia_RZ_RGB_Gradient.2f13b073.png";